import { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Spin,
  DatePicker,
  message,
  Space,
  Input,
  Select,
} from "antd";
import {
  PrinterOutlined,
  LoadingOutlined,
  PaperClipOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import styles from "../css/SendLawyerPage.module.css";
import axios from "axios";
import { generateLawyerReportPdf } from "../export/lawyerReportPdf.js";
import { generateCoverSheetPdf } from "../export/coverSheetPdf.js";
import AddImageAmc from "./AddImageAmc";
import UploadImageModal from "./UploadImage";
import {
  contractDetail,
  login_amc,
  searchcontracts,
  SEND_NOTE_AMC,
  GET_LOAD_IMAGE_NEW_ALL,
  HEADERS_UPIMAGE,
} from "../../../API/apiUrls";
import { IMAGE_TYPES } from "../constants";
import { optionsInterest } from "../../../../utils/constant/Interest.js";
import {
  latestDueDate,
  interestStart,
  resolveStart,
  daysFrom,
  calcInterest,
  DEFAULT_INTEREST_RATE,
} from "../export/pdfHelpers";

const fmtDate = (s) => (s ? dayjs(s).format("DD/MM/YYYY") : "-");
const thb = (n) =>
  Number(n || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const DocField = ({ label, value }) => (
  <div className={styles.docField}>
    <span className={styles.docFieldLabel}>{label}:</span>
    <span className={styles.docFieldValue}>{value ?? "-"}</span>
  </div>
);

export default function SendLawyerDetailModal({
  item,
  onClose,
  onSuccess,
  lawyer,
}) {
  const NNAME = localStorage.getItem("NNAME");
  const tokenRef = useRef(localStorage.getItem("TOKEN_AMC"));
  const token = localStorage.getItem("TOKEN");
  const [contractData, setContractData] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [calcDate, setCalcDate] = useState(dayjs()); // วันที่คิดดอกเบี้ยถึง
  const [startDate, setStartDate] = useState(null); // วันที่เริ่มคิด (null = ใช้ค่าเริ่มต้นของแต่ละบัญชี)
  const [interestRate, setInterestRate] = useState(DEFAULT_INTEREST_RATE); // อัตราดอกเบี้ย ONE
  const [operatorNote, setOperatorNote] = useState(""); // หมายเหตุที่ผู้ปฏิบัติงานกรอกเอง
  const [noteStatus, setNoteStatus] = useState(""); // สถานะงานที่ผู้ปฏิบัติงานกรอกเอง
  const [isModalAddImage, setIsModalAddImage] = useState(false);
  const [isModalUploadImage, setIsModalUploadImage] = useState(false);
  const [fileListByContractCourt, setFileListByContractCourt] = useState([]);
  const [loadingImge, setLoadingImge] = useState(false);
  const hasFetched = useRef(false);
  console.log("item", item);

  useEffect(() => {
    if (item?.borr_code && !hasFetched.current) {
      hasFetched.current = true;
      loadDataContract();
    }
  }, []);

  useEffect(() => {
    const idStocks = detail?.stock_contracts?.[0]?.id_stocks;
    if (idStocks) loadImge(idStocks);
  }, [detail]);

  const postLogin = async () => {
    const payload = {
      username: "admin666",
      password: "025601",
    };
    try {
      const res = await axios.post(login_amc, payload);
      const token = res.data?.token;
      if (res.status === 200 && token) {
        localStorage.setItem("TOKEN_AMC", token);
        tokenRef.current = token;
        return token;
      }
      message.error("ข้อมูลไม่ถูกต้อง");
      return null;
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("เกิดข้อผิดพลาด");
      return null;
    }
  };

  const isTokenExpiredError = (err) => {
    const msg = err?.response?.data?.message ?? "";
    return err?.response?.status === 401 || msg.includes("jwt");
  };

  const loadDataContract = async (isRetry = false) => {
    setLoading(true);
    try {
      const res = await axios.get(`${searchcontracts}${item.borr_code}`);
      const data = res.data?.data ?? res.data ?? null;
      setContractData(data);

      if (!tokenRef.current) {
        tokenRef.current = await postLogin();
      }
      if (!tokenRef.current) {
        setLoading(false);
        return;
      }

      const det = await axios.post(
        contractDetail,
        { borr_code: item.borr_code },
        { headers: { Authorization: `Bearer ${tokenRef.current}`, Menu: "1" } },
      );
      setDetail(det.data?.data ?? null);
    } catch (err) {
      if (isTokenExpiredError(err) && !isRetry) {
        localStorage.removeItem("TOKEN_AMC");
        tokenRef.current = null;
        await loadDataContract(true);
        return;
      }
      console.error("โหลดข้อมูลสัญญาไม่สำเร็จ", err);
      message.error("โหลดข้อมูลสัญญาไม่สำเร็จ");
    } finally {
      setLoading(false);
    }
  };

  const loadImge = async (idStocks, force = false) => {
    if (!idStocks) return;
    if (!force && fileListByContractCourt.length > 0) return;

    setLoadingImge(true);
    try {
      const res = await axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/11/${idStocks}`, {
        headers: HEADERS_UPIMAGE,
      });

      const validImageTypes = new Set(IMAGE_TYPES.map((t) => t.id));
      const allImages = (res.data || []).filter((f) =>
        validImageTypes.has(f.imageType),
      );
      setFileListByContractCourt(allImages);
    } catch (error) {
      console.error("โหลดเอกสารไม่สำเร็จ", error);
      setFileListByContractCourt([]);
    } finally {
      setLoadingImge(false);
    }
  };

  const handlePrint = () => {
    const result = contractData?.results?.[0] ?? null;
    const accounts = result?.accounts ?? [];
    const contracts = detail?.stock_contracts ?? [];

    generateLawyerReportPdf({
      result,
      accounts,
      detail,
      contractNo: item?.borr_code,
      contracts,
      calcDate,
      startDate,
      interestRate,
      item,
      operatorNote,
    });
  };

  const handlePrintCover = () => {
    const result = contractData?.results?.[0] ?? null;
    generateCoverSheetPdf({
      result,
      detail,
      item,
      accounts: result?.accounts ?? [],
      contracts: detail?.stock_contracts ?? [],
      calcDate,
      startDate,
      interestRate,
      files: fileListByContractCourt,
      operatorNote,
      responsible: lawyer,
    });
  };

  const handleSend = async (isRetry = false) => {
    const payload = {
      id_stock: detail?.stock_contracts?.[0]?.id_stocks,
      note: operatorNote,
      status: noteStatus,
      username: NNAME,
    };
    console.log("payload", payload);

    setSubmitting(true);
    try {
      if (!tokenRef.current) {
        tokenRef.current = await postLogin();
      }
      if (!tokenRef.current) {
        setSubmitting(false);
        return;
      }

      await axios.post(SEND_NOTE_AMC, payload, {
        headers: { Authorization: `Bearer ${tokenRef.current}`, Menu: "1" },
      });
      message.success("ส่งบังคับคดีสำเร็จ");
      onSuccess?.([
        {
          key:
            contracts?.loanNewId ??
            `${contracts?.DATA_TYPE}_${contracts?.CONTNO}`,
        },
      ]);
      onClose(false);
    } catch (error) {
      if (isTokenExpiredError(error) && !isRetry) {
        localStorage.removeItem("TOKEN_AMC");
        tokenRef.current = null;
        setSubmitting(false);
        await handleSend(true);
        return;
      }
      console.error("Error sending enforcement:", error);
      message.error(`ส่งบังคับคดีไม่สำเร็จ: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  const result = contractData?.results?.[0] ?? null;
  const accounts = result?.accounts ?? [];
  // map account_no → overdue (ใช้หา due_date ล่าสุดของแต่ละสัญญา)
  const overdueByAccount = Object.fromEntries(
    accounts.map((ac) => [ac.account_no, ac.overdue ?? []]),
  );
  const phones = detail?.customer_phones ?? [];
  const collaterals = detail?.stock_collaterals ?? [];
  const contracts = detail?.stock_contracts ?? [];
  const nationalId = detail?.customers[0]?.citizen_id;
  // วันที่เริ่มคิดต้องไม่ต่ำกว่า due_date ล่าสุดของทุกบัญชี
  const minStartDate = contracts.reduce((max, a) => {
    const d = latestDueDate(overdueByAccount[a.account_no]);
    return d && (!max || d.isAfter(max)) ? d : max;
  }, null);
  const defaultStartDate = contracts.length
    ? interestStart(overdueByAccount[contracts[0].account_no])
    : null;
  const startOf = (a) => resolveStart(overdueByAccount[a.account_no], startDate);
  const oneInterest = (a) =>
    calcInterest(a.principal_amount, startOf(a), calcDate, interestRate);

  return (
    <>
      <Modal
        open={true}
        onCancel={onClose}
        centered
        width={880}
        maskClosable={false}
        title={
          <div className={styles.modalTitle}>
            <span className={styles.modalContractNo}>{item.borr_code}</span>
          </div>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", gap: 8 }}>
              <Button
                icon={<PrinterOutlined />}
                onClick={handlePrint}
                loading={loading}
              >
                พิมพ์รายงาน
              </Button>
              <Button
                icon={<PaperClipOutlined />}
                onClick={() => setIsModalAddImage(true)}
                disabled={!contracts?.[0]?.id_stocks}
              >
                แนบเอกสาร
              </Button>
              <Button
                icon={<EyeOutlined />}
                onClick={() => setIsModalUploadImage(true)}
                disabled={fileListByContractCourt.length === 0}
                loading={loadingImge}
              >
                ดูเอกสาร
              </Button>
              <Button
                icon={<PrinterOutlined />}
                onClick={handlePrintCover}
                disabled={fileListByContractCourt.length === 0}
                loading={loading || loadingImge}
              >
                พิมพ์ใบปะหน้า
              </Button>
              {/* <Button icon={<PrinterOutlined />} onClick={handleCustomerInfoPrint} disabled={!result}>ข้อมูลลูกค้า</Button> */}
            </div>
            <Space>
              <Button danger onClick={onClose}>
                ปิด
              </Button>
              <Button
                type="primary"
                onClick={() => handleSend()}
                loading={loading}
              >
                บันทึก
              </Button>
            </Space>
          </div>
        }
      >
        <Spin
          spinning={loading}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          <div
            className={styles.detailBody}
            style={{ maxHeight: "72vh", overflowY: "auto", paddingRight: 4 }}
          >
            {/* ── ข้อมูลลูกค้า (document style) ── */}
            {result && (
              <div style={{ padding: "4px 2px 8px" }}>
                <div className={styles.docSection}>
                  <div className={styles.docSectionTitle}>ข้อมูลผู้กู้</div>
                  <DocField label="ชื่อ-นามสกุล" value={result.debtor_name} />
                  <DocField label="รหัสบัตรประชาชน" value={nationalId} />
                  <DocField label="Borr Code" value={result.borr_code} />
                </div>

                {phones.length > 0 && (
                  <div className={styles.docSection}>
                    <div className={styles.docSectionTitle}>เบอร์โทรศัพท์</div>
                    <table className={styles.docTable}>
                      <thead>
                        <tr>
                          <th>ประเภท</th>
                          <th>เบอร์โทรศัพท์</th>
                        </tr>
                      </thead>
                      <tbody>
                        {phones.map((p, i) => (
                          <tr key={p.phone_id ?? i}>
                            <td>{p.usage_label ?? "-"}</td>
                            <td>{p.telephone_num ?? "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {contracts.length > 0 && (
                  <div className={styles.docSection}>
                    <div
                      className={styles.docSectionTitle}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>สัญญาสินเชื่อ</span>
                      <Space>
                        ดอกเบี้ยที่ใช้คิด
                        <Select
                          size="small"
                          showSearch
                          options={optionsInterest}
                          optionFilterProp="label"
                          placeholder="อัตราดอกเบี้ย"
                          popupMatchSelectWidth={false}
                          value={interestRate}
                          onChange={(v) =>
                            setInterestRate(v ?? DEFAULT_INTEREST_RATE)
                          }
                        />
                        วันที่เริ่มคิด
                        <DatePicker
                          size="small"
                          value={startDate ?? defaultStartDate}
                          onChange={setStartDate}
                          disabledDate={(d) =>
                            (minStartDate &&
                              d.isBefore(minStartDate, "day")) ||
                            d.isAfter(calcDate, "day")
                          }
                          format="D MMM YYYY"
                          placeholder="วันที่เริ่มคิด"
                        />
                        ถึง
                        <DatePicker
                          size="small"
                          allowClear={false}
                          value={calcDate}
                          onChange={setCalcDate}
                          format="D MMM YYYY"
                          placeholder="วันที่คิดดอกเบี้ย"
                        />
                      </Space>
                    </div>
                    <table className={styles.docTable}>
                      <thead>
                        <tr>
                          <th>เลขที่บัญชี</th>
                          <th className={styles.docTableRight}>
                            เงินต้น (บาท)
                          </th>
                          <th className={styles.docTableRight}>
                            ดอกเบี้ย SCB (บาท)
                          </th>
                          <th>ช่วงวันที่</th>
                          <th className={styles.docTableRight}>จำนวนวัน</th>
                          <th className={styles.docTableRight}>
                            ดอกเบี้ย ONE (บาท) {+(interestRate * 100).toFixed(2)}%
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {contracts.map((a, i) => {
                          const start = startOf(a);
                          return (
                            <tr key={i}>
                              <td>{a.account_no ?? "-"}</td>
                              <td className={styles.docTableRight}>
                                {thb(a.principal_amount)}
                              </td>
                              <td className={styles.docTableRight}>
                                {thb(a.interest)}
                              </td>
                              <td>
                                {start
                                  ? `${fmtDate(start)} - ${fmtDate(calcDate)}`
                                  : "-"}
                              </td>
                              <td className={styles.docTableRight}>
                                {daysFrom(start, calcDate)}
                              </td>
                              <td className={styles.docTableRight}>
                                {thb(oneInterest(a))}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td style={{ fontWeight: 700 }}>รวม</td>
                          <td
                            className={styles.docTableRight}
                            style={{ fontWeight: 700 }}
                          >
                            {thb(
                              contracts.reduce(
                                (s, a) => s + Number(a.principal_amount || 0),
                                0,
                              ),
                            )}
                          </td>
                          <td
                            className={styles.docTableRight}
                            style={{ fontWeight: 700 }}
                          >
                            {thb(
                              contracts.reduce(
                                (s, a) => s + Number(a.interest || 0),
                                0,
                              ),
                            )}
                          </td>
                          <td></td>
                          <td></td>
                          <td
                            className={styles.docTableRight}
                            style={{ fontWeight: 700 }}
                          >
                            {thb(
                              contracts.reduce(
                                (s, a) => s + oneInterest(a),
                                0,
                              ),
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "baseline",
                        gap: 8,
                        marginTop: 8,
                        fontWeight: 700,
                      }}
                    >
                      <span>รวมทั้งหมด </span>
                      <span>
                        {thb(
                          contracts.reduce(
                            (s, a) =>
                              s +
                              Number(a.principal_amount || 0) +
                              Number(a.interest || 0) +
                              oneInterest(a),
                            0,
                          ),
                        )}{" "}
                        บาท
                      </span>
                    </div>
                  </div>
                )}

                {collaterals.length > 0 && (
                  <div className={styles.docSection}>
                    <div className={styles.docSectionTitle}>หลักประกัน</div>
                    {collaterals.map((s, i) => (
                      <div
                        key={i}
                        style={{ marginBottom: collaterals.length > 1 ? 8 : 0 }}
                      >
                        <DocField label="ประเภท" value={s.collateral_type} />
                        <DocField label="ที่ตั้ง" value={s.location} />
                        <DocField
                          label="ราคาประเมิน"
                          value={`${thb(s.latest_appraisal)} บาท`}
                        />
                      </div>
                    ))}
                  </div>
                )}

                <div className={styles.docSection}>
                  <div className={styles.docSectionTitle}>บริษัท</div>
                  <DocField
                    label="ชื่อบริษัท"
                    value={
                      result.company_name ??
                      "บริษัท วัน เอเอ็มซี จำกัด (สำนักงานใหญ่)"
                    }
                  />
                  <DocField
                    label="ที่อยู่"
                    value={
                      result.company_address ??
                      "89 หมู่ 14 ถ.มิตรภาพ ต.ในเมือง อ.เมืองขอนแก่น จ.ขอนแก่น 40000"
                    }
                  />
                </div>

                {
                  <div className={styles.docSection}>
                    <div className={styles.docSectionTitle}>
                      หมายเหตุจากเฮีย
                    </div>
                    <div>{item?.mark ? item?.mark : "ยังไม่มีบันทึก"}</div>
                  </div>
                }
                <div className={styles.docSection}>
                  <div className={styles.docSectionTitle}>
                    หมายเหตุจากผู้ปฏิบัติงาน
                  </div>
                  {(detail?.notes ?? []).length > 0 ? (
                    <table className={styles.docTable}>
                      <thead>
                        <tr>
                          <th>สถานะ</th>
                          <th>หมายเหตุ</th>
                          <th>บันทึกโดย</th>
                          <th>วันที่บันทึก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detail.notes.map((n, i) => (
                          <tr key={n.id_stocks ?? i}>
                            <td>{n.status ?? "-"}</td>
                            <td>{n.note ?? "-"}</td>
                            <td>{n.note_by ?? "-"}</td>
                            <td>{fmtDate(n.updated_at)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>ยังไม่มีบันทึก</div>
                  )}
                </div>

                <div className={styles.docSection}>
                  <div className={styles.docSectionTitle}>
                    เพิ่มสถานะ/หมายเหตุผู้ปฏิบัติงาน
                  </div>
                  <Input
                    value={noteStatus}
                    onChange={(e) => setNoteStatus(e.target.value)}
                    placeholder="ระบุสถานะงาน..."
                    style={{ marginBottom: 8 }}
                  />
                  <Input.TextArea
                    value={operatorNote}
                    onChange={(e) => setOperatorNote(e.target.value)}
                    placeholder="ระบุหมายเหตุ..."
                    autoSize={{ minRows: 2, maxRows: 5 }}
                  />
                </div>

                <hr className={styles.docDivider} />
              </div>
            )}

            {/* บัญชีสินเชื่อ (overdue รายงวด) */}
            {/* {accounts.map(acc => (
                        <div key={acc.id_sc} className={styles.detailSection}>
                            <div className={styles.detailSectionTitle} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span>บัญชี {acc.account_no}</span>
                                <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 11 }}>Running {acc.running_no}</span>
                                {acc.overdue_flag && (
                                    <Tag color="red" style={{ fontSize: 10, lineHeight: '16px', padding: '0 6px', margin: 0 }}>ค้างชำระ</Tag>
                                )}
                                <span style={{ marginLeft: 'auto', fontWeight: 600, color: '#dc2626', fontSize: 12 }}>
                                    ฿{thb(acc.principal_amount)}
                                </span>
                            </div>
                            {acc.overdue?.length > 0 && (
                                <div style={{ padding: '8px 14px 10px' }}>
                                    <Table
                                        dataSource={acc.overdue}
                                        columns={OVERDUE_COLS}
                                        size="small"
                                        pagination={false}
                                        rowKey={(_, i) => i}
                                        scroll={{ y: 200 }}
                                        style={{ fontSize: 12 }}
                                    />
                                </div>
                            )}
                        </div>
                    ))} */}

            {/* ข้อมูลการเจรจา */}
            {/* <div className={styles.detailSection}>
                        <div className={styles.detailSectionTitle}>ข้อมูลการเจรจา</div>
                        <div className={styles.detailGrid}>
                            <Row label="ผู้เจรจา" value={item.negotiate_by} />
                            <Row label="วันที่เจรจา" value={fmtDate(item.negotiate_date)} />
                            <Row label="วันนัดหมาย" value={fmtDate(item.meet_date)} />
                            <Row label="วันชำระล่วงหน้า" value={fmtDate(item.pre_pay_date)} />
                        </div>
                    </div> */}

            {/* สถานะส่งทนาย */}
            {/* <div className={styles.detailSection}>
                        <div className={styles.detailSectionTitle}>สถานะส่งทนาย</div>
                        <div className={styles.detailGrid}>
                            <Row
                                label="ส่งทนาย"
                                value={
                                    item.flag_send_lawyer
                                        ? <span className={styles.tagSent}>ส่งแล้ว</span>
                                        : <span className={styles.tagPending}>ยังไม่ส่ง</span>
                                }
                            />
                            <Row label="วันที่ส่งทนาย" value={fmtDate(item.date_send_lawyer)} />
                        </div>
                    </div> */}
          </div>
        </Spin>
      </Modal>

      {isModalAddImage && (
        <AddImageAmc
          open={isModalAddImage}
          close={() => setIsModalAddImage(false)}
          dataDefault={{
            judge: [
              {
                id_stocks: contracts?.[0]?.id_stocks,
                CONTNO: contracts?.[0]?.contract_no ?? item.borr_code,
                SNAM: result?.debtor_name,
              },
            ],
          }}
          onSuccess={() => {
            setIsModalAddImage(false);
            loadImge(contracts?.[0]?.id_stocks, true);
          }}
        />
      )}

      {isModalUploadImage && (
        <UploadImageModal
          open={isModalUploadImage}
          onClose={() => setIsModalUploadImage(false)}
          fileListByContractCourt={fileListByContractCourt}
          token={token}
          onAddImage={() => {
            setIsModalUploadImage(false);
            setIsModalAddImage(true);
          }}
        />
      )}
    </>
  );
}
